export default "__VITE_ASSET__BNGcSSN7__"